module.exports = __webpack_public_path__ + "img/14.9735177e.png";